import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';
import DataTableComponent from '../../common/DataTable/PrimeDataTable';
import { convertUTCToLocal } from '../../utils/dateUtils';
import { fetchProviders } from './paymentApiService';

const ProviderList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: 'sort_order',
    sortOrder: 1,
  });
  const [t] = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchProvidersData();
  }, []);

  const fetchProvidersData = async () => {
    setLoading(true);
    try {
      const response = await fetchProviders();
      setData(response.data || []);
    } catch (error) {
      console.error('Error fetching providers:', error);
    } finally {
      setLoading(false);
    }
  };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder,
    }));
  };

  const columns = [
    {
      field: 'display_name',
      header: t('name'),
      sortable: true,
      body: (rowData) => rowData.display_name,
    },
    {
      field: 'createdAt',
      header: t('createdAt'),
      sortable: true,
      body: (rowData) =>
        rowData.createdAt ? convertUTCToLocal(rowData.createdAt) : '—',
    },
    {
      field: 'is_active',
      header: t('status'),
      body: (rowData) => {
        if (rowData.is_active)
          return (
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{ color: '#198754' }}
            />
          );
        else
          return (
            <FontAwesomeIcon
              icon={faCircleXmark}
              style={{ color: '#ff0000' }}
            />
          );
      },
    },
  ];

  const actions = [
    {
      text: t('manage'),
      color: 'primary',
      onClick: (row) => navigate(`/admin/payments/${row.code}`),
    },
  ];

  return (
    <div>
      <DataTableComponent
        data={data}
        columns={columns}
        loading={loading}
        paginationParams={paginationParams}
        totalRecords={data?.length}
        onDataTableEvent={onDataTableEvent}
        enablePagination={true}
        enableLazyLoading={false}
        actions={actions}
        sectionName="PaymentProviders"
      />
    </div>
  );
};

export default ProviderList;
